import api from "../apiClient";

// Reveal a masked access-safety fact (gate_code / key_location only). The server
// audit-logs every reveal (who / when / tenant / customer / fact) — the client
// does not log. Frozen contract: docs/ACCESS_SAFETY_FACTS.md (Terminal B).
// POST /api/access-safety/facts/{fact_id}/reveal/  → {fact_id, fact_type, value, structured_value, revealed_at}
export const revealAccessSafetyFact = (factId) =>
  api.post(`/access-safety/facts/${factId}/reveal/`, {});
